import { useState, useEffect } from 'react';
import { warnOnce } from '../common.js';

const getWindowDimensions = () => {
  if (typeof window === "undefined") {
    return {
      width: 1920,
      height: 1080,
      mocked: true
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    mocked: false
  };
};
function useWindowDimensions() {
  if (typeof window === "undefined") {
    warnOnce(`useWindowDimensions hook is used in an SSR context. It will return desktop dimensions.
Please note that components using useWindowDimensions should be marked for client-side rendering.`);
  }
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    const handleResize = () => setWindowDimensions(getWindowDimensions());
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
    return () => {
      return;
    };
  }, []);
  return windowDimensions;
}

export { useWindowDimensions as default };
